<section>
  <header>
    <h1 auto="envisioning-title">Envisioning Phase</h1>
  </header>
  <div class="information-container">
    <div>
      <p><strong>Explore The Future</strong></p>
      <p>
        The Explore the Future subphase challenges an institution to focus on patterns, disruptors, and trends that could potentially be the source of ongoing issues or levers for positive change. This subphase is a template that allows you to identify future trends and sources within four distinct categories to determine which stakeholder group will be most impacted by each trend.
      </p>
      <p>
        In the Explore the Future subphase, begin by becoming knowledgeable about future trends and potential disruptors. Upload documents that identify these trends and disruptors to each corresponding trend. The trends are categorized into social, technological, economic, and political factors. Then, determine the stakeholder group that could be the most impacted by each trend and provides a brief explanation.
      </p>
    </div>
  </div>
  <div class="explanation-margin">
    <div class="download-guide-container">
      <img class="book-icon pointer" src="assets/images/download-guide-icon.svg" alt="book-icon" (click)="openGuide()">
      <span class="download-tagline pointer" (click)="openGuide()">Download the guide</span> to learn more about <strong>Explore The Future</strong>.
    </div>
  </div>
</section>
<section>
  <app-envisioning-table  [categoryLabel]="'Social Trends'"
                          [categoryColor]="'#324d5b'"
                          [subcategory]='socialTrends'
                          pageValue="ETF"
                          categoryValue="ST"
                          [isViewer]="isViewer()"
                          (addAttachment)="showAttachmentUploadModal($event)"
                          (editAttachment)="showAttachmentEditModal($event)"
                          (deleteAttachment)="onClickDeleteItem($event.resource, $event.label)">
  </app-envisioning-table>
  <app-envisioning-table  [categoryLabel]="'Technological Trends'"
                          [categoryColor]="'#45b39d'"
                          [subcategory]='technologicalTrends'
                          pageValue="ETF"
                          categoryValue="TT"
                          [isViewer]="isViewer()"
                          (addAttachment)="showAttachmentUploadModal($event)"
                          (editAttachment)="showAttachmentEditModal($event)"
                          (deleteAttachment)="onClickDeleteItem($event.resource, $event.label)"
  ></app-envisioning-table>
  <app-envisioning-table  [categoryLabel]="'Economic Trends'"
                          [categoryColor]="'#03bbbf'"
                          [subcategory]='economicTrends'
                          pageValue="ETF"
                          categoryValue="ET"
                          [isViewer]="isViewer()"
                          (addAttachment)="showAttachmentUploadModal($event)"
                          (editAttachment)="showAttachmentEditModal($event)"
                          (deleteAttachment)="onClickDeleteItem($event.resource, $event.label)">
  </app-envisioning-table>
  <app-envisioning-table  [categoryLabel]="'Political Trends'"
                          [categoryColor]="'#e13b3b'"
                          [subcategory]='politicalTrends'
                          pageValue="ETF"
                          categoryValue="PT"
                          [isViewer]="isViewer()"
                          (addAttachment)="showAttachmentUploadModal($event)"
                          (editAttachment)="showAttachmentEditModal($event)"
                          (deleteAttachment)="onClickDeleteItem($event.resource, $event.label)">
  </app-envisioning-table>

</section>

<app-attachment-upload-modal #attachmentUploadModal
                             [strategyId]="strategyId"
                             (resourceEdit)="editResource($event)"
                             (resourcesChange)="fetchData()"
                             (resourceCreated)="fetchData()"
></app-attachment-upload-modal>

<p-dialog #confirmDeleteDialog styleClass="strategies-confirm-dialog" [modal]="true" [closable]="false"
          appendTo="body">
  <p-header>
    <img src="assets/images/exclamation.svg" alt="Alert">
    <span class="dialog-title">Are You Sure?</span>
  </p-header>
  <div>Are you sure you want to delete {{ itemLabel }}?<br/></div>
  <p-footer>
    <button auto="upload-delete-cancel-btn" class="btn btn-alt" type="button" pButton label="Cancel"
            (click)="confirmDeleteDialog.visible = false">
    </button>
    <button auto="upload-delete-delete-btn" class="btn" type="button" pButton label="Delete"
            (click)="onConfirmDeleteDialogAccept()"></button>
  </p-footer>
</p-dialog>
